import { render, staticRenderFns } from "./AreaZones.vue?vue&type=template&id=884b862e&"
import script from "./AreaZones.vue?vue&type=script&lang=ts&"
export * from "./AreaZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports